import { createContext } from 'react';
import { getGlobalRouter } from './getGlobalRouter';
const router = getGlobalRouter();
const _routerContext = createContext(router);
export function getContext() {
    return _routerContext;
}
